import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { sizes } from "../../../enums";
import { UploaderMessages } from "./file-utils";
import ContentItem from "../../abstractions/content-item";
import AssetOverviewLayout from "./asset-overview";
import ItemThumbnail from "./item-thumbnail";
/**
 * displays a message over the file item showing the success message
 */

var UploadSuccessMessage = createComponent({
  displayName: 'UploadSuccessMessage',
  propTypes: {
    file: PropTypes.object.isRequired
  },
  render: function render(props) {
    var file = props.file;
    return /*#__PURE__*/React.createElement("div", {
      className: "upload-view upload-success-view"
    }, /*#__PURE__*/React.createElement(AssetOverviewLayout, {
      thumbnailContent: /*#__PURE__*/React.createElement(ItemThumbnail, {
        metaWidth: file.assetMeta && file.assetMeta.width || file.resolution && file.resolution.width || 0,
        metaHeight: file.assetMeta && file.assetMeta.height || file.resolution && file.resolution.height || 0,
        imageSrc: file.imageSrc,
        tooltip: file.fileName
      }),
      metaContent: /*#__PURE__*/React.createElement(ContentItem, {
        header: UploaderMessages.UPLOAD_SUCCESS,
        size: sizes.X7
      })
    }));
  }
});
export default UploadSuccessMessage;
//# sourceMappingURL=upload-success.js.map